//React
import React from 'react';

// Tanstack Query
import { QueryClient } from '@tanstack/react-query';

// Pages
import { ClaimManagement } from 'pages/claims';

// Store
import { useUserClaimManagementData } from './useUserClaimManagementData';

interface UserClaimManagementProps {
  queryClient: QueryClient;
}

export const UserClaimManagement: React.FC<UserClaimManagementProps> = ({
  queryClient,
}) => {
  const {
    claims,
    claimStatusesCount,
    actionNeededCount,
    providers,
    sites,
    status,
    payors,
    remittances,
    eobs,
    eobCounts,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    refetchClaims,
    refetchStatusesCount,
    invalidData,
    loadEobLookups,
  } = useUserClaimManagementData();

  return (
    <ClaimManagement
      claims={claims}
      claimStatuses={claimStatusesCount}
      actionNeededCount={actionNeededCount}
      providers={providers}
      sites={sites}
      status={status}
      payors={payors}
      remittances={remittances}
      eobs={eobs}
      eobCounts={eobCounts}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      setPagination={setPagination}
      pagination={pagination}
      invalidData={invalidData}
      errorMessage={errorMessage}
      refetchClaims={refetchClaims}
      refetchStatusesCount={refetchStatusesCount}
      loadEobLookups={loadEobLookups}
      queryClient={queryClient}
    />
  );
};
